import { propertyModel } from '../../modeller/propertyModel';

function PropertyMapSection({ property }) {
  const mapLinkUrl = propertyModel.createGoogleMapsLink(property);
  const googleEmbedUrl = propertyModel.createGoogleMapsEmbedUrl(property);

  return (
    <section className="mt-6 grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]" id="kart">
      <div className="overflow-hidden rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
        <div className="flex items-center justify-between gap-4 border-b border-[#18322812] px-6 py-5 md:px-8">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Kart</p>
            <h2 className="font-serif text-[clamp(1.8rem,3vw,2.5rem)] font-semibold leading-[1.08] text-[#163127]">
              Se eiendommen i Google Maps
            </h2>
          </div>
          {mapLinkUrl ? (
            <a
              className="focus-ring inline-flex min-h-11 items-center justify-center rounded-full border border-[rgba(29,76,59,0.18)] bg-[rgba(255,255,255,0.7)] px-5 font-semibold text-[#1d4c3b] no-underline"
              href={mapLinkUrl}
              aria-label={`Aapne ${property.name} i Google Maps i ny fane`}
              rel="noreferrer"
              target="_blank"
            >
              Aapne i Google Maps
            </a>
          ) : null}
        </div>
        {googleEmbedUrl ? (
          <div className="min-h-[380px]">
            <iframe
              className="h-[380px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src={googleEmbedUrl}
              title={`Google Maps for ${property.name}`}
            />
          </div>
        ) : (
          <div className="min-h-[380px] p-6 md:p-8" role="status">
            <div className="rounded-[24px] border border-[#18322812] bg-[rgba(255,255,255,0.52)] p-5">
              <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Kart utilgjengelig</p>
              <p className="m-0 text-[1.05rem] leading-[1.7] text-[#355046]">
                Vi kunne ikke laste kartvisning for denne adressen akkurat nå. Du kan fortsatt sende henvendelse for mer
                informasjon om beliggenhet.
              </p>
              <p className="sr-only">Kartvisning mangler for denne eiendommen. Fortsett til meld interesse-seksjonen for kontakt.</p>
            </div>
          </div>
        )}
      </div>

      <aside className="rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:p-8">
        <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Adresse</p>
        <p className="mb-2 font-semibold text-[#163127]">{property.name}</p>
        <p className="text-[1.05rem] leading-[1.8] text-[#355046]">{property.address}</p>
        <p className="mt-4 text-[1rem] leading-[1.7] text-[#355046]">
          Kartet viser området rundt eiendommen, slik at du enkelt kan se beliggenhet og avstand til områdene som er
          viktige for deg. Du kan åpne Google Maps for veibeskrivelse.
        </p>
        {mapLinkUrl ? (
          <a
            className="focus-ring mt-4 inline-flex min-h-11 items-center justify-center rounded-full border border-[rgba(29,76,59,0.18)] bg-[rgba(255,255,255,0.7)] px-5 font-semibold text-[#1d4c3b] no-underline"
            href={mapLinkUrl}
            rel="noreferrer"
            target="_blank"
          >
            Aapne i Google Maps
          </a>
        ) : null}
      </aside>
    </section>
  );
}

export default PropertyMapSection;